<script>
  export let first;
  export let second;
  $: valid=first>0 && second>0
</script>

<fieldset class={valid?"done":"todo"}>
  <legend><slot /></legend>
  <label>
    Prima misura:
    <input type="number" bind:value={first} />
    kg
  </label>
  <label>
    Seconda misura:
    <input type="number" bind:value={second} />
    kg
  </label>
</fieldset>

<style>
      fieldset {
        border-radius: 5px;
        background: #c4e7c3b9;
        margin: 1rem;
        padding: 1rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        position: relative;
        border: 2px groove threedface;
        max-width: 80ch;
      }


  label {
    max-width: 32ch;
    text-align: right;
  }
  input {
    width: 6em;
  }
  input:focus {
        border: 2px solid rgb(42, 44, 218);
      }

  .done{
    background-color: azure;
  }
</style>
